/**
 * @Author: wuyang
 * @Date: 2024/2/5
 * @Description: 全局事件监听的 service
 */

import {
	BaseAbstractClass,
	IBaseAbstractClassProps
} from '@/helper/base/BaseAbstractClass'
import { IBaseEventMitt } from '@/helper/base/BaseAtomMethodClass'
import { ITaskResultImage } from '@/types/task'
import { EBizPhone } from '@/types/bizPhone'
import { AtomManager } from '@/helper/managers/atom-manager/AtomManager'

interface IEventBusServiceMittProps extends IBaseEventMitt {}

interface IEventBusServiceProps
	extends IBaseAbstractClassProps<IEventBusServiceMittProps> {}

export class EventBusService extends BaseAbstractClass<
	IEventBusServiceProps,
	IEventBusServiceMittProps
> {
	// 4k 图片下载的总数量进度
	down4kImageAllMap = new AtomManager<string, ITaskResultImage>({})
	constructor(props: IEventBusServiceProps) {
		super(props)
		this.init(props)
	}
	async ready() {}

	// 增加 4k 的下载进度
	add4kImage(imageId: string) {
		this.down4kImageAllMap.addItem(imageId, {
			imageId,
			resImgUrl: '',
			resSmallImgUrl: '',
			follow: 0,
			zan: 0,
			progress: 0,
			queue: 0,
			taskOrdinalId: '',
			taskId: '',
			originalImgUrl: '',
			ordinal: 0,
			type: EBizPhone.goods,
			extra: ''
		} as ITaskResultImage)
	}

	// 删除 4k 的下载进度
	del4kImage(imageId: string) {
		this.down4kImageAllMap.delItem(imageId)
	}

	// 修改 4k 的下载进度
	update4kImage(imageId: string, data: ITaskResultImage) {
		this.down4kImageAllMap.updateItem(imageId, data)
	}

	async asyncInit(props: IEventBusServiceProps): Promise<void> {
		super.asyncInit(props)
	}
}
